/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BluetoothSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M213.91943,210.61865l-31.39087-34.53-.009-.01-31.35718-34.49292-.02148-.02343L53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627l70.8413,77.92553L51.19434,169.60254a7.9998,7.9998,0,1,0,9.5996,12.7998l51.2002-38.40014v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l50.83033-38.12292,26.4563,29.10193a7.99991,7.99991,0,0,0,11.83886-10.7627Zm-85.92529-2.61621v-64l11.76013,8.82007,25.05945,27.56519Z" />
        <Path d="M119.99414,79.62207a7.99977,7.99977,0,0,0,8-8V48.00244l42.6665,32L145.67041,98.74561a7.9998,7.9998,0,1,0,9.59961,12.7998l33.52392-25.14307a7.9995,7.9995,0,0,0,0-12.7998l-64-48a8,8,0,0,0-12.7998,6.3999V71.62207A7.99977,7.99977,0,0,0,119.99414,79.62207Z" />
      </G>
    </Svg>
  );
}

export default BluetoothSlash;
